const APP_ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'local'

const PRESET = {
  local: {
    urlAPI: 'http://localhost:3333/api/v1/',
    urlAPI2: 'http://localhost:3333/api/v2/',
    urlWeb: 'http://localhost:3000/',
    websocketURL: 'http://localhost:3005'
  },
  dev: {
    urlAPI: 'https://api.ruang-ilmiah.com/api/v1/',
    urlAPI2: 'https://api.ruang-ilmiah.com/api/v2/',
    urlWeb: 'https://appdev.ruangilmiah-dexa.com/',
    websocketURL: 'https://api.ruang-ilmiah.com'
  },
  prod: {
    urlAPI: 'https://api.ruangilmiah-dexa.com/api/v1/',
    urlAPI2: 'https://api.ruangilmiah-dexa.com/api/v2/',
    urlWeb: 'https://ruangilmiah-dexa.com/',
    websocketURL: 'https://api.ruangilmiah-dexa.com'
  }
}[APP_ENV] || {}

const urlAPI = process.env.REACT_APP_URL_API ?? PRESET.urlAPI
const urlAPI2 = process.env.REACT_APP_URL_API2 ?? PRESET.urlAPI2
const urlWeb = process.env.REACT_APP_URL_WEB ?? PRESET.urlWeb
const websocketURL = process.env.REACT_APP_WEBSOCKET_URL ?? PRESET.websocketURL

module.exports = {
  google: {
    API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || "",
    CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
    SECRET: process.env.REACT_APP_GOOGLE_SECRET || "",
  },
  facebook: {
    APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID || "",
  },
  urlAPI,
  urlAPI2,
  urlWeb,
  websocketURL,
}
